/* eslint-disable no-console */
import { register } from 'register-service-worker'

let activeServiceworker = null
let serviceworkerRegistration = null
const observedUpdateCandidates = new WeakSet()
export function getServiceworker() {
  return activeServiceworker
}
export function getServiceworkerRegistration() {
  return serviceworkerRegistration
}
export default function (store, i18n) {
  /* if (process.env.NODE_ENV !== 'production') {
    return false
  } */
  // Despite skipWaiting(), an installed worker only takes over once the old one has finished in-flight
  // requests (e.g. a background image revalidation), and reloading before then finds it waiting again.
  // So an update is only announced once the new worker has activated and controls this page.
  function observeUpdateCandidate(updateCandidate) {
    if (observedUpdateCandidates.has(updateCandidate)) {
      return
    }
    observedUpdateCandidates.add(updateCandidate)
    function announceUpdateOnceInControl() {
      const isRedundant = updateCandidate.state === 'redundant'
      const isInControl = updateCandidate.state === 'activated' && navigator.serviceWorker.controller === updateCandidate
      if (!isRedundant && !isInControl) {
        return
      }
      updateCandidate.removeEventListener('statechange', announceUpdateOnceInControl)
      navigator.serviceWorker.removeEventListener('controllerchange', announceUpdateOnceInControl)
      if (isRedundant) {
        return
      }
      store.commit('setUpdateAvailable', true)
      if (!window.Capacitor) {
        store.commit('notifications/addNotification', {
          topic: i18n.t('notifications.update_available'),
          title: i18n.t('notifications.reload_to_update'),
          callback() {
            window.location.reload()
          },
          actions: {
            [i18n.t('notifications.reload_app')]() {
              window.location.reload()
            },
          },
        })
      }
      console.log('New content is available; please refresh.')
    }
    updateCandidate.addEventListener('statechange', announceUpdateOnceInControl)
    navigator.serviceWorker.addEventListener('controllerchange', announceUpdateOnceInControl)
    announceUpdateOnceInControl()
  }
  register('/serviceworker.js', {
    registrationOptions: { scope: '/' },
    cached() {
      console.log('Content has been cached for offline use.')
    },
    error(error) {
      console.error('Error during service worker registration:', error)
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.')
    },
    ready(registration) {
      serviceworkerRegistration = registration

      activeServiceworker = registration.active
      console.log('App is being served from cache by a service worker.')
      registration.active.postMessage({
        event: 'setConfig',
        data: store.getters['auth/config'],
      })
      window.setTimeout(() => {
        // Reload svgs to update their colors
        Array.from(document.querySelectorAll('img[src*=".svg"]')).forEach((img) => {
          img.src = `${img.src}?${(new Date()).getTime()}`
        })
      }, 500)
    },
    registered(registration) {
      console.log('Service worker has been registered.')
      // register-service-worker stops watching a registration that already has a waiting worker,
      // so a newer worker replacing that one would otherwise never be announced.
      if (registration.waiting) {
        registration.addEventListener('updatefound', () => {
          observeUpdateCandidate(registration.installing)
        })
        if (registration.installing) {
          observeUpdateCandidate(registration.installing)
        }
      }
    },
    updated(registration) {
      observeUpdateCandidate(registration.waiting)
    },
    updatefound() {
      console.log('New content is downloading.')
    },
  })
  return true
}
